import {
  GET_ADMIN_USER_NOTIFICATIONS,
  GET_ADMIN_USER_NOTIFICATIONS_SUCCESS,
  GET_ADMIN_USER_NOTIFICATIONS_ERROR,
  CREATE_USER_NOTIFICATIONS,
  CREATE_USER_NOTIFICATIONS_SUCCESS,
  CREATE_USER_NOTIFICATIONS_ERROR,
  UPDATE_USER_NOTIFICATIONS,
  UPDATE_USER_NOTIFICATIONS_SUCCESS,
  UPDATE_USER_NOTIFICATIONS_ERROR,
  DELETE_USER_NOTIFICATIONS,
  DELETE_USER_NOTIFICATIONS_SUCCESS,
  DELETE_USER_NOTIFICATIONS_ERROR,
  EXPORT_ADMIN_USER_NOTIFICATIONS,
  EXPORT_ADMIN_USER_NOTIFICATIONS_SUCCESS,
  EXPORT_ADMIN_USER_NOTIFICATIONS_ERROR,
} from "./actionTypes"

export const getAdminUserNotifications = (query_params, paginated) => {
  return {
    type: GET_ADMIN_USER_NOTIFICATIONS,
    payload: query_params,
    paginated: paginated
  }
}

export const getAdminUserNotificationsSucess = (user_notifications, meta = {}) => {
  return {
    type: GET_ADMIN_USER_NOTIFICATIONS_SUCCESS,
    payload: user_notifications,
    meta,
  }
}

export const getAdminUserNotificationsError = error => {
  return {
    type: GET_ADMIN_USER_NOTIFICATIONS_ERROR,
    payload: error,
  }
}

export const createUserNotifications = (user_notifications) => {
  return {
    type: CREATE_USER_NOTIFICATIONS,
    payload: user_notifications
  }
}

export const createUserNotificationsSucess = user_notifications => {
  return {
    type: CREATE_USER_NOTIFICATIONS_SUCCESS,
    payload: user_notifications,
  }
}

export const createUserNotificationsError = error => {
  return {
    type: CREATE_USER_NOTIFICATIONS_ERROR,
    payload: error,
  }
}

export const updateUserNotifications = (user_notifications) => {
  return {
    type: UPDATE_USER_NOTIFICATIONS,
    payload: user_notifications
  }
}

export const updateUserNotificationsSucess = user_notifications => {
  return {
    type: UPDATE_USER_NOTIFICATIONS_SUCCESS,
    payload: user_notifications,
  }
}

export const updateUserNotificationsError = error => {
  return {
    type: UPDATE_USER_NOTIFICATIONS_ERROR,
    payload: error,
  }
}

export const deleteUserNotifications = (user_notifications) => {
  return {
    type: DELETE_USER_NOTIFICATIONS,
    payload: user_notifications
  }
}

export const deleteUserNotificationsSucess = user_notifications => {
  return {
    type: DELETE_USER_NOTIFICATIONS_SUCCESS,
    payload: user_notifications,
  }
}

export const deleteUserNotificationsError = error => {
  return {
    type: DELETE_USER_NOTIFICATIONS_ERROR,
    payload: error,
  }
}

export const exportAdminUserNotifications = (query_params) => {
  return {
    type: EXPORT_ADMIN_USER_NOTIFICATIONS,
    payload: query_params
  }
}

export const exportAdminUserNotificationsSuccess = () => {
  return {
    type: EXPORT_ADMIN_USER_NOTIFICATIONS_SUCCESS,
  }
}

export const exportAdminUserNotificationsError = error => {
  return {
    type: EXPORT_ADMIN_USER_NOTIFICATIONS_ERROR,
    payload: error,
  }
}
